import { T } from '@tribeplatform/react-components/i18n'

import { CaptchaSettings } from '../CaptchaSettings.js'

export function CaptchaRouter() {
  return <CaptchaSettings />
}

export function CaptchaBreadCrumb() {
  return <T id="Security.Captcha" defaultMessage="CAPTCHA" />
}
